// Angular
import { Component, OnInit, HostListener, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { Router } from '@angular/router';

// localforage
import * as localforage from 'localforage';

// date-fns
import { distanceInWords } from 'date-fns';

// services
import { DrawerService } from '@app/services/drawer/drawer.service';
import { ApiService } from '@app/services/api/api.service';

// components
import { SearchBarComponent } from '@app/components/search-bar/search-bar.component';

@Component({
  selector: 'oh-open-house-select',
  templateUrl: './open-house-select.component.html',
  styleUrls: ['./open-house-select.component.scss'],
})
export class OpenHouseSelectComponent implements OnInit {
  private token: any;
  public lastSynced: any;
  public lastSyncedHelpText: string;
  public data: any;
  public openHouses: any;
  public tabs: any;
  public activeTab: string;
  public images: any[];
  @ViewChild('tooltip') tooltip: any;
  @ViewChild(SearchBarComponent) searchBar: any;

  constructor(private drawerService: DrawerService, private router: Router, private apiService: ApiService) {
    this.tabs = ['My Open Houses', 'Company Open Houses'];
    this.activeTab = this.tabs[0];
  }

  async ngOnInit() {    
    this.token = await this.apiService.getTokenFromDatabase();

    if (navigator.onLine) {
      try {
        await this.getData();
      } catch (error) {
        console.log(error);
      }

      try {
        // save last synced date
        await localforage.removeItem('oh-last-synced');
        localforage.setItem('oh-last-synced', new Date());
      } catch (error) {
        console.log(error);
      }
    }

    await this.getDataFromDatabase();

    this.lastSynced = await this.getLastSyncedDate();

    this.lastSyncedHelpText =
      this.data && this.data.lastSyncedHelpText
        ? this.data.lastSyncedHelpText
        : 'To get a fresh list of open houses, connect to the internet and refresh the page.';

    this.images = this.getAllImages();
  }

  @HostListener('window:touchmove')
  @HostListener('scroll')
  private hideTooltip() {
    this.tooltip.hide(0);
  }

  private async getLastSyncedDate() {
    const lastSyncedDateString: any = await localforage.getItem('oh-last-synced');
    const lastSyncedDate = new Date(lastSyncedDateString);
    const timeAgo = distanceInWords(new Date(), lastSyncedDate);
    return timeAgo;
  }

  private async getData() {
    let data;

    try {
      data = await this.apiService.getAgentData(this.token);
    } catch (error) {
      console.log(error);
    }

    if (data) {
      await this.apiService.saveAgentDataToDatabase(data);
    }
  }

  private getAllImages(): any[] {
    if (!this.data) {
      return;
    }

    const images = [];

    if (!this.data || !this.data.open_houses) {
      return;
    }

    // open house images
    for (const oh of this.data.open_houses) {
      images.push(oh.primary_photo);
    }

    // agent image
    images.push(this.data.photo);

    // company logo image
    images.push(this.data.company_information.logos.horiz);    

    return images;
  }

  private async getDataFromDatabase() {
    try {
      this.data = await this.apiService.getAgentDataFromDatabase();
    } catch (error) {
      console.error(error);
    }

    if (this.data && this.data.open_houses) {
      this.openHouses = this.data.open_houses;
      this.disablePastOpenHouses();
    } else {
      this.openHouses = [];
    }

    if (this.data) {
      if (this.data.open_houses) {
        this.openHouses = this.data.open_houses;
        this.disablePastOpenHouses();
      } else {
        this.openHouses = [];
      }
      if (this.data.idx_opens_enabled) {
        this.tabs.push("IDX Open Houses");
      }
    }
  }

  private disablePastOpenHouses() {
    this.openHouses.map((house) => {
      const openHouseDate = new Date(house.open_date);
      const today = new Date();
      const yesterday = new Date(today.setDate(today.getDate() - 1));
      if (openHouseDate >= yesterday) {
        house.closed = false;
      } else {
        house.closed = true;
      }
      return house;
    });
  }

  public refresh() {
    window.location.reload();
  }

  public async selectOpenHouse(openHouse: any) {
    await localforage.setItem('oh-selected-open-house', openHouse);
    this.drawerService.dismiss();
    this.router.navigate(['/welcome']);
  }

  getOpenHouses(){
    if (this.openHouses !== undefined && this.searchBar !== undefined) {
      return this.openHouses.filter(oh =>
        (this.searchBar.value === undefined || this.searchBar.value === '' || oh.address.toLowerCase().indexOf(this.searchBar.value) !== -1)
        && (
          (this.activeTab === "My Open Houses" && (this.data.uid === undefined || +oh.aid === +this.data.uid))
          || (this.activeTab === "Company Open Houses" && oh.cid === this.data.company_information.cid && +oh.aid !== +this.data.uid)
          || (this.activeTab === "IDX Open Houses" && oh.cid !== this.data.company_information.cid)
        )
      );
    }
    return false;
  }
}
